export default {
	purple: {
		700: '#2E224C',
		600: '#453473',
		500: '#574191',
		400: '#7356BF',
		300: '#957FCE',
		200: '#C1B5E3',
		100: '#E3DDF2',
		50: '#F4F1FA',
	},
	cobalt: {
		700: '#050C4D',
		600: '#081270',
		500: '#0A1899',
		400: '#0E1FC1',
		300: '#535FCF',
		200: '#949CE3',
		100: '#D2D7F0',
		50: '#EBEDFA',
	},
	blue: {
		700: '#102C60',
		600: '#174291',
		500: '#1E54B7',
		400: '#276EF1',
		300: '#5B91F5',
		200: '#A0BFF8',
		100: '#D4E2FC',
		50: '#EFF3FE',
	},
	green: {
		700: '#10462D',
		600: '#03582F',
		500: '#03703C',
		400: '#05944F',
		300: '#06C167',
		200: '#66D19E',
		100: '#ADDEC9',
		50: '#E6F2ED',
	},
	yellow: {
		700: '#674D1B',
		600: '#997328',
		500: '#BC8B2C',
		400: '#FFC043',
		300: '#FFCF70',
		200: '#FFE3AC',
		100: '#FFF2D9',
		50: '#FFFAF0',
	},
	orange: {
		700: '#672A16',
		600: '#9A3F21',
		500: '#C14F29',
		400: '#FF6937',
		300: '#FA9269',
		200: '#FABDA5',
		100: '#FFE1D6',
		50: '#FFF3EF',
	},
	red: {
		700: '#5A0A00',
		600: '#870F00',
		500: '#AB1300',
		400: '#E11900',
		300: '#E85C4A',
		200: '#F1998E',
		100: '#FED7D2',
		50: '#FFEFED',
	},
	brown: {
		700: '#3D281E',
		600: '#5C3C2E',
		500: '#744C3A',
		400: '#99644C',
		300: '#B18977',
		200: '#D2BBB0',
		100: '#EBE0DB',
		50: '#F6F0EA',
	},
	gray: {
		700: '#11171C',
		600: '#2D3843',
		500: '#4D5C6A',
		400: '#77818B',
		300: '#9AA5AF',
		200: '#BFC6CD',
		100: '#E9EDEF',
		50: '#F6F8F9',
	},
	black: '#000000',
	white: '#FFFFFF',
}
